import axios from 'axios';

export const http = {
    $http: axios
};
